import React, { Suspense, lazy, useEffect } from "react";
import { Navigate, Routes, Route, BrowserRouter } from "react-router-dom";
import ReactGA from "react-ga4";
import Loading from "./components/Loading";

// Pages
const Layout = lazy(() => import("./layouts"));
const Home = lazy(() => import("./pages/general/home"));
const Product = lazy(() => import("./pages/general/product"));
const TheProduct = lazy(() => import("./pages/general/product/detail"));
const AboutGraphene = lazy(() => import("./pages/general/about-graphene"));
const TheArticle = lazy(() => import("./pages/general/about-graphene/article"));
const TheApplication = lazy(() => import("./pages/general/application/detail"));
const ContactUs = lazy(() => import("./pages/general/contact-us"));
const PrivacyPolicy = lazy(() => import("./pages/general/privacy-policy"));
const Login = lazy(() => import("./pages/no-auth/login"));
const Application = lazy(() => import("./pages/general/application"));
const EndProduct = lazy(() => import("./pages/general/end-product"));
const DetailEndProduct = lazy(
  () => import("./pages/general/end-product/detail"),
);

function App() {
  useEffect(() => {
    ReactGA.initialize([
      {
        trackingId: "G-QFRTLXWE5L",
      },
      {
        trackingId: "G-XRX2GEBYL1",
      },
      {
        trackingId: "G-QJ88J8CGZ4",
      },
    ]);

    // This will send a pageview to both trackers
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);
  return (
    <BrowserRouter basename="/">
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/product" element={<Product />} />
            <Route path="/product/:id" element={<TheProduct />} />
            <Route path="/blog" element={<AboutGraphene />} />
            <Route path="/blog/article/:slug" element={<TheArticle />} />
            <Route path="/application" element={<Application />} />
            <Route path="/application/:id" element={<TheApplication />} />
            <Route path="/end-product" element={<EndProduct />} />
            <Route path="/end-product/:id" element={<DetailEndProduct />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            <Route path="*" element={<Navigate to="/" />} />
          </Route>

          <Route path="/login" element={<Login />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
